import { useEffect, type ReactNode } from "react";

export function Modal({
  title, who, meta, onClose, children,
}: {
  title: string;
  who?: string;
  meta?: ReactNode;
  onClose: () => void;
  children: ReactNode;
}) {
  useEffect(() => {
    const esc = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, [onClose]);

  // The page behind stays put: on a phone it would otherwise scroll under the
  // modal and carry the modal along with it.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  return (
    <div id="modal" className="on" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="box">
        <div className="hd">
          <b>{title}</b>
          {who && <span className="who">{who}</span>}
          {meta && <span className="meta">{meta}</span>}
          <button className="x" onClick={onClose} aria-label="close">×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function fmtDur(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
}
